/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Table, Input, Empty, DatePicker, Tabs, message } from 'antd'
// import './index.scss'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'

import UserNameLabel from '../../../components/Custom/UserNameLabel'
import SubscribeProgress from '../subscribeProgress'

const { RangePicker } = DatePicker
const dateFormat = 'll'
const { TabPane } = Tabs

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			dateRange: [],
			isExporting: false,
			exportProgress: null
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// reservation_status: filters.status,
		})
	}

	render() {
		const { AuthStore } = this.props
		const { user_uid, barangay_uid } = AuthStore
		const { page, pageSize, sortOrder, sortName, searchText, dateRange = [],
			isExporting, exportProgress
		} = this.state
		let filters = { 
			page, pageSize, searchText, sortOrder, sortName
		}
		if (dateRange.length > 0) {
			const startDate = moment(dateRange[0]).format('YYYY-MM-DD')
			const endDate = moment(dateRange[1]).format('YYYY-MM-DD')
			filters = Object.assign({}, filters, {
				date_start: startDate,
				date_end: endDate
			})
		}

		const certificate_name = 'certificate-community-tax'
		return (
			<Row>
				<Col md={24} sm={24}>
					<Row>
						<Col md={6} sm={24}>
							{
								(dateRange.length > 0) &&
								<button 
									type="button" 
									className="btn btn-outline-success btn-rounded waves-effect waves-light"
									onClick={() => {
										const { exportReports } = this.props
										const params = {
											date_start: moment(dateRange[0]).format('YYYY-MM-DD'),
											date_end: moment(dateRange[1]).format('YYYY-MM-DD'),
											searchText: searchText
										}
										exportReports(params)
									}}
								>
									<i className='mdi mdi-file-excel'/> Generate Report
								</button>
							}
						</Col>
						<Col md={18} sm={24}>
							<Row style={{ textAlign: 'right' }}>
								<RangePicker
									// showTime
									format={dateFormat}
									style={{ marginRight: 20, width: 300 }}
									onChange={(value) => {
										// console.log('range picker value', value)
										this.setState({ dateRange: value })
									}}
								/>
								<Input 
									style={{ width: 200 }}
									placeholder='Search Here..' 
									onChange={(e)=>{
										this.setState({ searchText: e.target.value })
									}}/>
							</Row>
						</Col>
					</Row>
					<br />
					<Row>
						<Query query={CERTIFICATE_CLEARANCE} variables={{ searchFilter: filters, barangay_uid }}>
							{({ loading, error, data, subscribeToMore }) => {
								if (error) return <Empty/>

								let certificates = _.has(data,'allCommunityTaxClearance') ? data.allCommunityTaxClearance.data : []
								certificates = certificates.map((certificate, key) => Object.assign({}, certificate, { key }))
								let _pagination = _.has(data, 'allCommunityTaxClearance') ? data.allCommunityTaxClearance.pagination : {}
								_pagination = Object.assign({}, _pagination, {
									pageSizeOptions: ['10', '25', '50'],
									showSizeChanger: true,
									total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
									showTotal: (total) => `Total ${total} items`
								})

								const columns = [{
									title: '#',
									key: 'control_number',
									dataIndex: 'control_number',
									width: 100
								}, {
									title: 'Name',
									key: 'name',
									dataIndex: 'name'
								}, {
									title: 'CTC Number',
									key: 'ctc_number',
									dataIndex: 'ctc_number'
								}, {
									title: 'Purpose',
									key: 'purpose',
									dataIndex: 'purpose'
								},  {
									title: 'Request Date',
									key: 'request_date',
									render: (record) => {
										return (
											<span>{moment(record.request_date).format('ll')}</span>
										)
									}
								}, 
								//{
								//	title: 'OR Number',
								//	key: 'or_number',
								//	dataIndex: 'or_number'
								//}, 
								{
									title: 'Amount',
									key: 'amount',
									dataIndex: 'amount',
								}, {
									title: 'Issued By',
									key: 'created_by',
									render: (record) => {
										return <UserNameLabel user_uid={record.created_by} />
									}
								}]
								return (
									<Row>
										<Row style={{ marginBottom: 10 }}>
											<SubscribeProgress
												exportProgress={exportProgress}
												isExporting={isExporting}
												subscribeToExportProgress={() => {
													subscribeToMore({
														document: EXPORT_PROGRESS,
														variables: { user_uid, process_name: certificate_name },
														updateQuery: (prev, { subscriptionData }) => {
															// console.log('[NEW_MESSAGE] previous value', prev)
															// console.log('[NEW_MESSAGE] subscriptionData value', subscriptionData)
															if (_.isEqual(subscriptionData.data.exportProgress.status, 'exporting')) {
																this.setState({ isExporting: true, exportProgress: subscriptionData.data.exportProgress })
															} else {
																this.setState({ isExporting: false, exportProgress: null })
															}
														}
													})
												}}
											/>
										</Row>
										<Row>
											<Table 
												loading={loading}
												columns={columns} 
												dataSource={certificates} 
												bordered
												onChange={this.handleOnChange}
												pagination={_pagination}
												scroll={{ x: 'calc(700px + 50%)', y: 1080 }}
											/>
										</Row>
									</Row>
								)
							}}
						</Query>
					</Row>
				</Col>
			</Row>
		)
	}
}

const CERTIFICATE_CLEARANCE = gql`
    query allCommunityTaxClearance($barangay_uid: String, $searchFilter: SearchParams) {
		allCommunityTaxClearance(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const EXPORT_REPORTS = gql`
    mutation exportCTCReports($input: JSON) {
		exportCTCReports(input: $input)
    }
`

const EXPORT_PROGRESS = gql`
	subscription exportProgress($user_uid: String, $process_name: String) {
		exportProgress(user_uid: $user_uid, process_name: $process_name)
	}
`

const composed = compose(
	inject('AuthStore'),
	graphql(EXPORT_REPORTS, {
		props({ mutate }) {
			return {
				exportReports(params) {
					return mutate({
						variables: { input: params },
					  	// refetchQueries: ['visitorLogs']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
